const corporate_store = () => {
	const elem = document.querySelectorAll("[class*='js-corporate-store-'");
	if(elem.length > 0){
		let html = '';
		for (let i = 0; i < elem.length; i++) {
			json_import('store', (json)=>{
				const data = json.company_info;
				const classList = elem[i].classList[elem[i].classList.length-1].split('-');

				switch (classList[classList.length-1]) {
					case 'profile':
						html += data.count.sum+'店舗（'+data.updated_at+'現在）<br>';
						html += '大阪府：'+data.count.osaka+'店舗<br>';
						for (let j = 2; j < json.area.length; j++) {
							html += json.area[j].pref+'：'+data.count[json.area[j].category]+'店舗<br>';
						}
						break;
					case 'vision':
						html += '大阪府'
						for (let j = 2; j < json.area.length; j++) {
							html += '・'+json.area[j].pref;
						}
						html += 'に'+data.count.sum+'店舗を展開しています。';
						html += '（'+data.updated_at+'時点）';
						break;
				}
				elem[i].innerHTML = html;
			});
		}
	}
}